import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

import { DeleteOrganizationModal } from './delete-organization-modal';

export const DeleteOrganizationCard = () => {
  const { t } = useTranslation('authenticated.organization');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Card>
        <CardContent className="pt-6">
          <h3 className="mb-2 text-lg font-semibold">{t('deleteOrganization.title')}</h3>
          <p className="mb-6 text-sm text-muted-foreground">
            {t('deleteOrganization.description')}
          </p>
          <Button variant="destructive" onClick={() => setIsModalOpen(true)}>
            {t('deleteOrganization.button')}
          </Button>
        </CardContent>
      </Card>

      <DeleteOrganizationModal
        open={isModalOpen}
        onOpen={() => setIsModalOpen(true)}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
